import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { HTTP_STATUSES, MAX_PAGE_SIZE } from "@miplatform/constants";
import { AccountType } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

export const useSpecDetailFormViewModel = ({ stateManager, setValue }) => {
  const [customerOptions, setCustomersOptions] = useState([]);
  const [seriesOptions, setSeriesOptions] = useState([]);
  const [specLevelOptions, setSpecLevelOptions] = useState([]);

  const GET_CUSTOMER_OPTIONS_UUID = createUUID();
  const GET_SERIES_OPTIONS_UUID = createUUID();

  const getCustomerOptions = () => {
    stateManager.abort(GET_CUSTOMER_OPTIONS_UUID);
    stateManager.run(async () => {
      const { status, data } = await accountService.accounts.getAll({
        sort: "name",
        top: MAX_PAGE_SIZE,
        filters: { accountType: AccountType.Builder },
      });
      if (status === HTTP_STATUSES.OK) {
        const options = data.map((account) => ({
          label: account.name,
          value: account.id,
        }));
        setCustomersOptions(options);
      }
    }, GET_CUSTOMER_OPTIONS_UUID);
  };

  const getSeriesOptions = (id, seriesOrCommunityId) => {
    stateManager.abort(GET_SERIES_OPTIONS_UUID);
    stateManager.run(async () => {
      const response = await homeService.series.getAll({
        sort: "name",
        filters: { accountId: { type: "guid", value: id } },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const seriesOptions = response.data.map((series) => ({
          label: series.name,
          value: series.id,
        }));
        const specLevelOptions = response.data.map((series) => ({
          label: series.specLevel,
          value: series.specLevel,
        }));
        setSeriesOptions(seriesOptions);
        setSpecLevelOptions(specLevelOptions);

        const selectedSpecLevel = response.data.find(
          (series) => series.id === seriesOrCommunityId
        );
        if (selectedSpecLevel) {
          setValue("specLevel", selectedSpecLevel.specLevel);
        }
      }
    }, GET_SERIES_OPTIONS_UUID);
  };

  return {
    customerOptions,
    seriesOptions,
    specLevelOptions,
    getCustomerOptions,
    getSeriesOptions,
  };
};
